const popperConfigDrop = {
    strategy: "fixed",
    onFirstUpdate: () => window.dispatchEvent(new CustomEvent('scroll')),
};

export {popperConfigDrop};